<div fxLayout="center center" fxFill>
  <h1 *ngIf="!isAuthorized && !loginSimulated">Simulating Login...</h1>
  <h1 *ngIf="!isAuthorized && loginSimulated">
    Waiting for push authorization...
  </h1>
  <h1 *ngIf="isAuthorized && loginSimulated">Login Successful!</h1>
</div>
